var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1103,
    height: 286,
    viewBox: "0 0 1103 286",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.1185 207.04C115.542 207.04 132.585 192.776 138.741 169.352L172.225 180.763C160.513 216.199 132.585 238.572 92.1185 238.572C38.8144 238.572 0 196.154 0 135.267C0 74.4555 38.8144 31.9624 92.1185 31.9624C132.585 31.9624 160.513 54.26 172.225 89.7711L138.741 101.183C132.585 77.7589 115.542 63.4944 92.1185 63.4944C59.16 63.4944 35.7363 91.9483 35.7363 135.267C35.7363 178.511 59.16 207.04 92.1185 207.04Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.462 194.728C184.462 166.799 205.408 154.562 233.562 148.706L274.028 140.297V137.82C274.028 123.856 266.746 115.222 248.878 115.222C232.961 115.222 224.628 122.504 220.649 136.694L189.117 129.411C196.399 105.162 217.871 86.1675 250.229 86.1675C285.365 86.1675 306.611 102.909 306.611 136.694V199.758C306.611 208.166 310.215 210.644 319.449 209.518V235.494C295.2 238.272 282.362 233.542 277.331 221.53C268.097 231.89 252.782 237.972 233.787 237.972C206.009 237.972 184.462 220.929 184.462 194.728ZM274.103 165.973L242.571 172.655C228.307 175.733 217.721 180.163 217.721 193.301C217.721 204.713 226.129 211.169 238.968 211.169C256.836 211.169 274.103 201.71 274.103 183.842V165.973Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M371.252 220.103V285.72H337.768V88.9453H371.252V104.561C380.486 93.6751 394.45 86.1675 413.369 86.1675C454.436 86.1675 477.86 120.778 477.86 162.37C477.86 203.962 454.436 238.572 413.369 238.572C394.375 238.572 380.411 230.989 371.252 220.103ZM370.351 166.799C370.351 193.902 385.967 209.217 406.613 209.217C430.862 209.217 444.001 190.223 444.001 162.295C444.001 134.366 430.862 115.372 406.613 115.372C385.967 115.372 370.351 130.462 370.351 158.09V166.799Z",
    fill: "#F2F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M497.68 35.0405H532.29V69.3503H497.68V35.0405ZM531.69 235.494H498.206V88.9452H531.69V235.494Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M567.126 117.399H546.78V88.9454H567.126V45.9268H600.084V88.9454H630.79V117.399H600.084V193.301C600.084 206.44 607.592 207.791 619.604 207.791C625.159 207.791 628.238 207.491 633.268 206.965V235.194C627.111 236.32 618.778 237.146 610.069 237.146C582.141 237.146 567.05 228.512 567.05 198.632V117.399H567.126Z",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M645.055 194.728C645.055 166.799 666.001 154.562 694.154 148.706L734.62 140.297V137.82C734.62 123.856 727.338 115.222 709.47 115.222C693.554 115.222 685.22 122.504 681.241 136.694L649.709 129.411C656.992 105.162 678.464 86.1675 710.821 86.1675C745.957 86.1675 767.204 102.909 767.204 136.694V199.758C767.204 208.166 770.807 210.644 780.042 209.518V235.494C755.792 238.272 742.954 233.542 737.924 221.53C728.689 231.89 713.374 237.972 694.38 237.972C666.526 237.972 645.055 220.929 645.055 194.728ZM734.62 165.973L703.089 172.655C688.824 175.733 678.238 180.163 678.238 193.301C678.238 204.713 686.647 211.169 699.485 211.169C717.353 211.169 734.62 201.71 734.62 183.842V165.973Z",
    fill: "#F2F2F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M831.769 235.494H798.285V35.0405H831.769V235.494Z",
    fill: "#F2F2F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M857.445 35.0405H892.055V69.3503H857.445V35.0405ZM891.455 235.494H857.971V88.9452H891.455V235.494Z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1027.57 88.9451H914.353V117.399H1004.14L1027.57 88.9451Z",
    fill: "#F2F2F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M905 236H1103V0L905 236Z",
    fill: "#2C2960"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M905 236H1103V0L905 236Z",
    fill: "url(#paint0_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M905 236H1103V0L905 236Z",
    fill: "url(#paint1_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M905 236H1103V0L905 236Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 980,
    y1: 118,
    x2: 1103,
    y2: 118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19CEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 1183.5,
    y1: -0.00000240653,
    x2: 992.322,
    y2: 212.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2960",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 1183.5,
    y1: 150,
    x2: 1029.55,
    y2: 194.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2960",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo.84bce022.svg";
export { ForwardRef as ReactComponent };